
import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
// import '@ag-grid-community/core/dist/styles/ag-grid.css';
// import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import SweetAlert from 'react-bootstrap-sweetalert';
// import UpdateButton from "./updatelmstates";
// import UpdateTransitButton from "./updatetransitbutton";
// import * as Datetime from 'react-datetime';
// import 'react-datetime/css/react-datetime.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import redirectURL from "../redirectURL";

import $ from 'jquery';
import { getDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS, getHyphenDDMMYYYY } from '../common/utils'; 
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var alertIcon_50 = require("../../assets/icons/accident alert_16.jpeg");
var moment = require('moment');
var CELL_DIMENSION_SIZE = 90;
var googleAnalytics = require("../common/googleanalytics");
var axios = require('axios');
var decipher = salt => {
    const textToChars = text => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded => encoded.match(/.{1,2}/g)
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var localStorageRole = (localStorage.getItem("role"));



export default class TransitDelayReport extends Component {

    constructor(props) {
        super(props);
		this.displayData = [];
        this.state = {
			pageTitle: "Transporter GPS Overspeed",
			eventGridAction: "gridAction",
			eventCounterAction: "counterAction",
			eventFormAction: "formAction",
			showform:'show-m',
			loadshow:'show-n',
			showrefresh:'show-n',
			sliderTranslate:'',
			showdata:this.displayData,
        	radius:'15',
			rlatitude:'',
			rlongitude:'',
			latitude:'',
			longitude:'',
			defaultradius:0,
			coordinates:[],
			alert:null,
            show: false,
            basicTitle:'',
            basicType:"default",
			contentString:"testing",
			mwidth:"col-xl-12 col-lg-12",
			dept_code:'',
			defaultColDef: {
				sortable: true,
				filter: true,
				//editable: true,
				resizable: true
			},
			rowData: [],
			truckList: [],
			originalrowData: [],
			selectedTabLat:'',
			selectedTabLng:'',
			cluster_centroids: [],
			deftab:'all',
			rowModelhighchartoptionsType: 'enterprise',
			rowGroupPanelShow: 'always',
			animateRows: true,
			debug: true,
			showToolPanel: false,
			rowSelection: "single" ,
			context: { componentParent: this },
			frameworkComponents : {
				// // showtptgpsmap:ShowTPTGpsMap,
                // UpdateButton:UpdateButton,
                // UpdateTransitButton:UpdateTransitButton,
            },
			loadingCellRenderer: "customLoadingCellRenderer",
			loadingCellRendererParams: { loadingMessage: "One moment please..." },
			rowModelType: "serverSide",
			paginationPageSize:50,
			cacheBlockSize: 50,
			maxBlocksInCache: 2,
		
			showPlant:'show-n',
			showAddr:'show-n',
			request_type:'',
			view_type:'',
			tabplants:[],
			clickabletab:'',
			plantlist:[],
			stateFormData : "",
			sliderStateEmailsTranslate : "",
			overly : "show-n",
            rakeslist : [],
            loadingpoints:[],
            destinationpoints:[],
            userType:"",
            pinnedRegionBottomRowData:[],
            pinnedTransitBottomRowData:[],
            stockData:[],
            totalStock:0,
            totalSales:0,
            totalDispatches:0,
            railShare:0,
            totalFySales:0,
            totalFyDispatches:0,
            railFyShare:0,
            pendingForDispatchStock:0,
            transitStock:0,
            unloadingUpdatedDate:"",
            intransitUpdatedDate:"",
            screenView: "",
            todayInstalled: [],
            totalInstalled: [],
            statusBar: {
				statusPanels: [
					{
					statusPanel: "agTotalAndFilteredRowCountComponent",
					align: "left"
					},
					{
					statusPanel: "agTotalRowCountComponent",
					align: "center"
					},
					{ statusPanel: "agFilteredRowCountComponent" },
					{ statusPanel: "agSelectedRowCountComponent" },
					{ statusPanel: "agAggregationComponent" }
				]
			},
			sideBar: {
				toolPanels: [
					{
					id: "columns",
					labelDefault: "Columns",
					labelKey: "columns",
					iconKey: "columns",
					toolPanel: "agColumnsToolPanel"
					},
					{
					id: "filters",
					labelDefault: "Filters",
					labelKey: "filters",
					iconKey: "filter",
					toolPanel: "agFiltersToolPanel"
					}
				]
			},
			filteredData: [],
			truckNoList:[],
			showTrucksList : "show-n",
			startDate: moment.parseZone().subtract(1, 'months').format("YYYY-MM-DD"),
            endDate: moment.parseZone().format("YYYY-MM-DD"),
			truckNos:[],
			mapinfo:[],
            // duration:"",
			sliderRouteTranslate:'',
			tpttrucks:[],
            truck_no:[],
            tpt_code:[],
            truck_no_options:[],
            tpt_code_option:[],
            lastElement:"",
            lastNumbers:0,
            allData:[],
            page_no:0,
            alrData:0,
            total_count:[],
            transporter_name:[],
            // from_date: moment.parseZone().subtract(5,'days').format("YYYY-MM-DD"),
            // to_date: moment.parseZone().format("YYYY-MM-DD"),
		};
		// this.onShowTPTGPSMapRoute = this.onShowTPTGPSMapRoute.bind(this);
	}
	/*Alert Popups*/
	closeAlert = () => {
        this.setState({
            show: false
        });
        
        
    }
    onChangeDuration(duration){
		this.setState(
			{ duration },
			// () => console.log(`duration Option selected:`, this.state.duration)
		);
	}
	logPageView = () => {
		try {
			if (googleAnalytics.page.enableGA) {
				googleAnalytics.logPageView();
				let eventGridAction = googleAnalytics.page.actionType.gridAction + " - " + window.location.pathname;
				let eventCounterAction = googleAnalytics.page.actionType.counterAction + " - " + window.location.pathname;
				let eventFormAction = googleAnalytics.page.actionType.formAction + " - " + window.location.pathname;
				this.setState({eventGridAction: eventGridAction, eventCounterAction: eventCounterAction, eventFormAction: eventFormAction});
			} else {
				console.log("GA disabled...");
			}
		} catch(error) {
			console.error("Error occured while logging to GA, error = ", error);
		}
	}
    componentDidMount(){
        this.getApiData();	

    }
    
    getApiData = async () => {
        
		var rowData = []	
        
        // loadDateTimeScript();
        // var from_date = moment.parseZone().subtract(30,'days').format("YYYY-MM-DD")
        // var to_date = moment.parseZone().format("YYYY-MM-DD")
        // $("#stfromDate").val(from_date);
		// $("#sttoDate").val(to_date);
		var params = {
			// transporter_code:transporter_code,
			// startdate : from_date,
			// enddate : to_date
		}
           
          
       await redirectURL.post("/transitdelayreport",params)
        .then((response) =>{
            rowData = response.data;
            var records = response.data;
            var truckList = records.map(item=> item.truck_no)
            var transportersList = records.map(item=> item.transporter_name)
            
            
            if(truckList != null && truckList != undefined)
            {
                var trucksData = [];
                truckList.map((e) => {
                    trucksData.push({"label": e, "value": e})
                })
            }
            

            var tptcodes =[];
            if(transportersList != null && transportersList != undefined)
            {
                transportersList.map((e)=>{
                    // if(tptcodes.filter(k => k.value == e.transporter_code).length == 0 )
                    // {
                        // tptcodes.push({"label": e.transporter_name, "value": e.transporter_code})
                        tptcodes.push({"label": e, "value": e})
                    // }
                   
                })
            }
            

            // console.log(trucksData,"trucksData")
            // console.log(tptcodes,"tptcodes")
            
			this.setState({
				rowData,
                truck_no_options: trucksData,
                tpt_code_option:tptcodes

			})
        })
    }

	onClickHideAll(){
		this.setState({
			overly : "show-n",
			showTrucksList : "show-n",
			sliderRouteTranslate:'',
		})
	}
	hideList(){
        this.setState({
			loadshow:'show-n',
			overly:'show-n',
			showTrucksList : "show-n",
        });
    }
	
    onGridReady = params => {
		this.gridApi = params.api;
		//console.log("Grid is: ", params);
		this.gridColumnApi = params.columnApi;
    };
    

	// onClickFilterSafetyReport = () => {
	// 	// var truckNos = this.state.truckNos;
	// 	// var truck_nos = [];
	// 	// if(truckNos.length > 0)
	// 	// {
	// 	// 	truckNos.map(function(e){
	// 	// 		truck_nos.push(e.value)
	// 	// 	});
	// 	// }
	// 	var truckNo = $("#inputTruck").val();
    //     // var truck_no = [];
    //     // if(truckNo.length > 0)
	// 	// {
	// 	// 	truckNo.map(function(e){
	// 	// 		truck_no.push(e.value)
	// 	// 	});
	// 	// }
    //     // var tptcode = this.state.tpt_code;
    //     var tptcode = this.state.transporter_name;
    //     var tpt_code = [];
    //     if(tptcode !=null && tptcode != "null")
    //     {
    //         if(tptcode.length > 0)
    //         {
    //             tptcode.map(function(e){
    //                 tpt_code.push(e.value)
    //             });
    //         }
    //     }
        
        
	// 	var from_date = this.state.startDate
	// 	var to_date = this.state.endDate
    //         // var transporter_code = [];
    //         // if(localStorage.getItem("transportercode")!=undefined && localStorage.getItem("transportercode")!="undefined")
    //         // {
    //         //     var transporter_code = JSON.parse(localStorage.getItem("transportercode"))
    //         // }
    //         // console.log("reqfilter", truckNo, from_date, to_date)
    //         if(from_date != '' || to_date != '' || truckNo !='' || tpt_code !='')
    //         {	
    //             //     console.log(from_date, to_date)
    //             //     from_date = moment.parseZone(new Date(from_date)).utcOffset("+05:30")._d
    //             //     to_date = moment.parseZone(new Date(to_date)).utcOffset("+05:30")._d
    //             //     var datediff = (to_date - from_date)
    //             //     var diffDays = Math.floor(datediff / 86400000)
    //             //     console.log(diffDays,"diffDays")
    //             //     if(diffDays <= 5)
    //             //     {
    //                 if(from_date != undefined && from_date != "" && to_date != undefined && to_date != "")
    //                 {
    //                     from_date = moment.parseZone(new Date(from_date)).utcOffset("+05:30").format("YYYY-MM-DD")
    //                     to_date = moment.parseZone(new Date(to_date)).utcOffset("+05:30").format("YYYY-MM-DD")
    //                 }
    //                 var check = 0 ; 
    //                 if(from_date !=undefined && from_date !="")
    //                 {
    //                     if(to_date ==undefined || to_date == "")
    //                     {
    //                         check  = 1 ;
    //                     }
    //                 } 
    //                 if(to_date !=undefined && to_date !="")
    //                 {
    //                     if(from_date ==undefined || from_date == "")
    //                     {
    //                         check  = 2 ;
    //                     }
    //                 }
    //                 if(check == 0)
    //                 {
    //                     var reqparams = {		
    //                         // transporter_code:transporter_code,	
    //                         truck_no : truckNo,
    //                         tpt_code:tpt_code,
    //                         startdate : from_date,
    //                         enddate : to_date,
    //                     }
                    
    //                     // console.log("reqparams ", reqparams)
    //                     this.setState({
    //                         loadshow:'show-m',
    //                         overly:'show-m',
    //                     })
    //                     redirectURL.post("/transitdelayreportfilterdata",reqparams)    
    //                     .then((response) => {
    //                         var records = response.data;
    //                         console.log(records,"records")
    //                         this.setState({
    //                             loadshow:'show-n',
    //                             overly:'show-n',
    //                             rowData:records
    //                         })
                            
    //                     })
    //                     .catch(function(e){
    //                         console.log("Error ",e)
    //                     })
    //                 }    
    //             // }
    //                 else
    //                 {
    //                     this.setState({
    //                         show:true,
    //                         basicTitle:'From Date and To Date are required',
    //                         basicType:"danger",
    //                         loadshow:'show-n',
    //                     })
    //                 }
    //         }
        
    //         else
    //         {
    //             this.setState({
    //                 show:true,
    //                 basicTitle:'Please select atleast one input',
    //                 basicType:"danger",
    //                 loadshow:'show-n',
    //             })
    //         }
		
	// }
    onClickFilterSafetyReport = () => {
        // Get truck number from the state (from react-select)
        const truckNo = this.state.truck_no ? this.state.truck_no.value : ""; // assuming truck_no holds a single selected truck
        const tptCodeArray = this.state.tpt_code || [];
        let tpt_code = [];
    
        // Check if `tpt_code` has values, if so, map and push them
        if (tptCodeArray.length > 0) {
            tpt_code = tptCodeArray.map((e) => e.value);
        }
    
        // Get date range from state
        let from_date = this.state.startDate;
        let to_date = this.state.endDate;
    
        // Check if at least one of the inputs (truckNo, tpt_code, or date) is filled
        if (from_date || to_date || truckNo || tpt_code.length > 0) {
            // If both dates are provided, format them
            if (from_date && to_date) {
                from_date = moment.parseZone(new Date(from_date)).utcOffset("+05:30").format("YYYY-MM-DD");
                to_date = moment.parseZone(new Date(to_date)).utcOffset("+05:30").format("YYYY-MM-DD");
            }
    
            // Check date logic to ensure both dates are provided when one is missing
            let check = 0;
            if (from_date && !to_date) {
                check = 1;
            } else if (to_date && !from_date) {
                check = 2;
            }
    
            if (check === 0) {
                // Build the request parameters
                const reqparams = {
                    truck_no: truckNo,
                    tpt_code: tpt_code,
                    startdate: from_date,
                    enddate: to_date,
                };  
            //     var location_name = localStorage.getItem("location");
            //     location_name = (location_name && location_name !=="undefined" && location_name !==null) ? location_name.split(",").filter(Boolean) : [];
            //     var locationNameConversion = location_name.map(e => e.trim().toLowerCase());
            //     var entity1 = localStorage.getItem("entity")
            //   entity1 = (entity1 && entity1 !== "undefined" && entity1.trim() !== "" && entity1 !== null) 
            //   ? entity1.split(",").map(x => x.trim()).filter(Boolean) 
            //   : [];    
            //   var entityConversion = entity1.map(e=> e.trim().toLowerCase())
            //   var state1 = localStorage.getItem("state");
            //   state1 = (state1 && state1 !== "undefined" && state1.trim() !== "" && state1 !== null) 
            //   ? state1.split(",").map(x => x.trim()).filter(Boolean) 
            //   : []; 
              
            //   var stateConversion = state1.map(e => e.trim().toLowerCase());    
          
            //   var zone1 = localStorage.getItem("zone");
            //   zone1 = (zone1 && zone1 !== "undefined" && zone1.trim() !== "" && zone1 !== null) 
            //   ? zone1.split(",").map(x => x.trim()).filter(Boolean) 
            //   : []; 
            //   var zoneConversion = zone1.map(e => e.trim().toLowerCase()); 

            //   if (
            //     zoneConversion &&
            //     zoneConversion.length > 0 &&
            //     !["all"].some((item) => zoneConversion.includes(item))
            //             ) {                      
            //             reqparams.consigner_zone = zoneConversion;
            //                   }
            //                   if (
            //                     stateConversion &&
            //                     stateConversion.length > 0 &&
            //                     !["all"].some((item) => stateConversion.includes(item))
            //                             ) {                      
            //                             reqparams.consigner_state = stateConversion;
            //                                   }
        
            //         if (
            //             locationNameConversion &&
            //             locationNameConversion.length > 0 &&
            //             !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
            //                     ) {                      
            //                     reqparams.consigner_name = locationNameConversion;
            //                     reqparams.consigner_code = locationNameConversion;
            //                           }
            //                           if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
            //                             reqparams.truck_seal_entity = entityConversion
            //                         } 
                    
    
                // Show loading indicators
                this.setState({
                    loadshow: 'show-m',
                    overly: 'show-m',
                });
    
                // Make API request
                redirectURL.post("/transitdelayreportfilterdata", reqparams)
                    .then((response) => {
                        const records = response.data;
                        console.log(records, "records");
    
                        // Update state with received data and hide loading indicators
                        this.setState({
                            loadshow: 'show-n',
                            overly: 'show-n',
                            rowData: records,
                        });
                    })
                    .catch((e) => {
                        console.log("Error ", e);
                    });
            } else {
                // If date logic is incorrect, show an error message
                this.setState({
                    show: true,
                    basicTitle: 'From Date and To Date are required',
                    basicType: "danger",
                    loadshow: 'show-n',
                });
            }
        } else {
            // If no inputs are provided, show an error message
            this.setState({
                show: true,
                basicTitle: 'Please select at least one input',
                basicType: "danger",
                loadshow: 'show-n',
            });
        }
    }
    

    handleStartDateChange = (date) => {
        if (this.state.endDate && date > this.state.endDate) {
            alert("From Date cannot be greater than To Date.");
        } else {
            this.setState({ startDate: date });
        }
    }

    handleEndDateChange = (date) => {
        if (this.state.startDate && date < this.state.startDate) {
            alert("To Date cannot be less than From Date.");
        } else {
            this.setState({ endDate: date });
        }
    }

	onChangeDepartment(truckNos){
		this.setState(
			{ truckNos },
			() => console.log(`truckNos Option selected:`, this.state.truckNos)
		);
	}

    handlerFromDateTime = (event, currentDate, selectedDate) => {
        
        var from_date = moment(new Date(event._d)).format('YYYY-MM-DD');
        this.setState({
            from_date
        });
    }
    handlerToDateTime = (event, currentDate, selectedDate) => {      
		var to_date = moment(new Date(event._d)).format('YYYY-MM-DD');

		this.setState({
            to_date
        });
    }

	initalList = () => {
        const dataset = this.state.truck_no_options;
        const tpttrucks = this.state.tpttrucks;
        let tptunqrecords = [];
    
        // If tpttrucks is not empty, push each filtered item into tptunqrecords
        if (tpttrucks.length > 0) {
            tptunqrecords = dataset.filter((f) => tpttrucks.includes(f));
        } else {
            tptunqrecords = dataset;
        }
    
        // Limit the records to the first 100 entries
        tptunqrecords = tptunqrecords.slice(0, 100);
    
        // Update state for filtered data and truck list visibility
        this.setState({
            filteredData: tptunqrecords,
            truck_no_options: tptunqrecords.map((truck) => ({
                value: truck,
                label: truck
            })),  // Set the filtered trucks as the dropdown options
            showTrucksList: "show-m",
        });
    }
    
    handlerForm = (selectedOption) => {
        // const dataset = this.state.truck_no_options;
        // let tptunqrecords = [];
    
        // Get the selected value from react-select
        // const inputVal = selectedOption ? selectedOption.label : "";
    
        // if (dataset.length > 0) {
        //     tptunqrecords = dataset;
        // } else {
        //     tptunqrecords = dataset;
        // }
    
        // Filter the truck records based on the selected input value
        // const filteredResult = tptunqrecords.filter((e) => {
        //     return e && e.toString().toLowerCase().includes(inputVal.toLowerCase());
        // });
    
        // Limit the filtered results to the first 100 entries
        // const limitedFilteredResult = filteredResult.slice(0, 100);
    
        // Update state with the filtered results and show the dropdown list
        this.setState({
            truck_no: selectedOption,
            // filteredData: limitedFilteredResult,
            // truck_no_options: limitedFilteredResult.map((truck) => ({
            //     value: truck,
            //     label: truck
            // })),  // Update the select options based on the filtered result
            // showTrucksList: "show-m",
        });
    }




    render(){
        
		var columnWithDefs= [
			// {
			// 	headerName: "Serial No",
			// 	field: "numbers",
            //     width: 100,
            //     filter: true,
            //     resizable: true,
            //     sortable:true,
			// },
            {
				headerName: "Truck No",
				field: "truck_no",
                width: 140,
                filter: true,
                resizable: true,
                sortable:true,
                headerClass: 'bold-header'
			},
            {
				headerName: "LR No",
				field: "lr_no",
                width: 140,
                filter: true,
                resizable: true,
                sortable:true,
                headerClass: 'bold-header'
			},
            {
				headerName: "Invoice No",
				field: "invoice_no",
                width: 160,
                filter: true,
                resizable: true,
                sortable:true,
                headerClass: 'bold-header'
			},
            {
				headerName: "Transporter Name",
				field: "transporter_name",
                width: 180,
                filter: true,
                resizable: true,
                sortable:true,
                valueGetter: function(params){
                    if(params.data.transporter_name !=undefined && params.data.transporter_name !='')
					{
						return params.data.transporter_name
					}
					else
					{
						return "N/A";
					}
                },
                headerClass: 'bold-header'
			},
            {
				headerName: "Expected Trip End",
				field: "expected_trip_end",
                width: 180,
                filter: true,
                resizable: true,
                sortable:true,
                valueGetter: function(params){
                    if(params.data.expected_trip_end !=undefined && params.data.expected_trip_end !='')
					{
						return getHyphenDDMMMYYYYHHMM(params.data.expected_trip_end)
					}
					else
					{
						return "N/A";
					}
                },
                headerClass: 'bold-header'
			},
            {
				headerName: "Dealer Reached",
				field: "recent_dealer_reported",
                width: 180,
                filter: true,
                resizable: true,
                sortable:true,
                valueGetter: function(params){
                    if(params.data.recent_dealer_reported !=undefined && params.data.recent_dealer_reported !='')
					{
						return  getHyphenDDMMMYYYYHHMM(params.data.recent_dealer_reported)
					}
					else
					{
						return "N/A";
					}
                },
                headerClass: 'bold-header'
			},
            {
				headerName: "Transit Delay Hours",
				field: "transit_delay_hours",
                width: 180,
                filter: true,
                resizable: true,
                sortable:true,
                valueGetter: function(params){
                    if(params.data.transit_delay_hours !=undefined && params.data.transit_delay_hours !='')
					{
						return params.data.transit_delay_hours
					}
					else
					{
						return "N/A";
					}
                },
                headerClass: 'bold-header'
			},
            {
				headerName: "Transit Delay Days",
				field: "transit_delay_hours",
                width: 180,
                filter: true,
                resizable: true,
                sortable:true,
                valueGetter: function(params){
                    if(params.data.transit_delay_hours !=undefined && params.data.transit_delay_hours !='')
					{
						return (params.data.transit_delay_hours/24).toFixed(1)
					}
					else
					{
						return "N/A";
					}
                },
                headerClass: 'bold-header'
			},
           
			
          
		];
		var listData = [] 
        // eslint-disable-next-line array-callback-return
        this.state.filteredData.map(function(e){
        listData.push(<li className="dropdown-truck-no">{e}</li>)
        })
        return (
            <>
            <div className="row ml-5p">
                <div className="col-sm-12">
                        <h5 className="f18 master-title">
							<i class="icofont icofont-vehicle-delivery-van cus-i"></i>
                        	Transit Delay Report
                        </h5>
                    </div>
            </div>  
    		<div className={(this.state.screenView == "Mobile")?"":"container-fluid"} style={(this.state.screenView == "Mobile")?{marginTop:"2em"}: {}}>
				<SweetAlert
	            show={this.state.show}
	            type={this.state.basicType}
	            title={this.state.basicTitle}
	            onConfirm={this.closeAlert}
                >
                </SweetAlert>
                
                <div className="card">
                    {/* <div className="card-header">
                      
                    </div> */}
                    <div className={(this.state.screenView == "Mobile")?"card-body":"card-body col-xl-12 col-lg-12"}>
						<div className={"trucks-dropdown "+this.state.showTrucksList} style={{top:"94px"}}>
							<ul>
								{listData}
							</ul>
						</div>
						<div class="row">
                        <div class={" col-xl-3 col-lg-3 form-group"}>
								{/* <label>Trucks </label>
								<Select 
								placeholder={"Trucks"}
								closeMenuOnSelect={false}
								isMulti={true}
								onChange={(e)=>{this.setState({truck_no:e})}}
								className={"border-radius-0"}
								style={{borderRadius:"0px"}}
								options={this.state.truck_no_option} /> */}
								<label style={{fontWeight:"700", fontSize:"13px"}}>Trucks </label>
								{/* <input 
                                    type="text" 
                                    name="truck_no" 
                                    id="inputTruck"  
                                    placeholder={"Trucks"}
                                    autoComplete="off" 
                                    className="form-control" 
                                    onFocus={this.initalList.bind(this)}  */}
                                    {/* onChange={this.handlerForm.bind(this)} /> */}
                                  <Select
                                        name="truck_no"
                                        id="inputTruck"
                                        placeholder={"Truck No"}  // Same placeholder as the input
                                        autoComplete="off"
                                        className=""  // Keeping the same class
                                        value={this.state.truck_no}  // Controlled value for the selected truck
                                        // onFocus={this.initalList}  // Preserving the onFocus functionality
                                        onChange={this.handlerForm}  // Handle selection and pass the selected value to handlerForm
                                        options={this.state.truck_no_options}  // Options for the dropdown
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: '35px',    // Decrease the height of the dropdown control
                                                height: '35px',       // Set a specific height
                                                fontSize: '12px',     // Reduce font size for the control
                                                padding: '0px',       // Remove extra padding
                                            }),
                                            valueContainer: (base) => ({
                                                ...base,
                                                padding: '0px 8px',   // Adjust the padding inside the value container
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                margin: '0px',        // Remove margin around the input field
                                                padding: '0px',       // Remove padding inside the input
                                            }),
                                            indicatorsContainer: (base) => ({
                                                ...base,
                                                height: '30px',       // Align the dropdown indicators with the reduced height
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                fontSize: '12px',     // Reduce font size for dropdown options
                                            })
                                        }}
                                    />    
							</div>
                            <div class={" col-xl-3 col-lg-3 form-group"}>
								<label style={{fontWeight:"700", fontSize:"13px"}}>Transporter </label>
								<Select 
								placeholder={"Transporter"}
								closeMenuOnSelect={false}
								isMulti={true}
								// onChange={(e)=>{this.setState({tpt_code:e})}}
								onChange={(e)=>{this.setState({transporter_name:e})}}
								className={"border-radius-0"}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '35px',    // Decrease the height of the dropdown control
                                        height: '35px',       // Set a specific height
                                        fontSize: '12px',     // Reduce font size for the control
                                        padding: '0px',       // Remove extra padding
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        padding: '0px 8px',   // Adjust the padding inside the value container
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        margin: '0px',        // Remove margin around the input field
                                        padding: '0px',       // Remove padding inside the input
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: '30px',       // Align the dropdown indicators with the reduced height
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        fontSize: '12px',     // Reduce font size for dropdown options
                                    })
                            }}								options={this.state.tpt_code_option} />
							</div>
                            <div className="col-xl-2 col-lg-2 form-group">
                                <label style={{fontWeight:"700", fontSize:"13px"}}>From Date</label>
                                <DatePicker
                                    selected={this.state.startDate}
                                    onChange={this.handleStartDateChange}
                                    className="form-control"
                                    // id="ndfromDate"
                                    autoComplete="off"
                                    placeholderText="From date"
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                        showYearDropdown
                                        showMonthDropdown
                                />
                            </div>
                            <div className="col-xl-2 col-lg-2 form-group">
                                <label style={{fontWeight:"700", fontSize:"13px"}}>To Date</label>
                                <DatePicker
                                    selected={this.state.endDate}
                                    onChange={this.handleEndDateChange}
                                    className="form-control"
                                    // id="ndtoDate"
                                    autoComplete="off"
                                    placeholderText="To date"
                                    dateFormat="dd/MM/yyyy"
                                    onKeyDown={(e) => e.preventDefault()}
                                    showYearDropdown
                                    showMonthDropdown
                                />
                            </div>
							{/* <div class="col-xl-2 col-lg-2 form-group">
								<label>From Date</label>
								<input type="text" name="date" id="stfromDate" autoComplete="off" className="datetimepicker_date form-control" />
							</div>
                            <div class="col-xl-2 col-lg-2 form-group">
								<label>To Date</label>
								<input type="text" name="date" id="sttoDate" autoComplete="off" className="datetimepicker_date form-control" />
							</div> */}

                               
                            {/* <div class="col-xl-2 col-lg-2 form-group">
								<label>Break Duration</label>
                                <Select 
                                    placeholder={"Duration"}
                                    // isMulti={true}s
                                    onChange={this.onChangeDuration.bind(this)}
                                    className={"border-radius-0"}
                                    style={{borderRadius:"0px"}}
                                    value={this.state.duration}
                                    options={[
                                        {value:"10",label:"10 Mins"},
                                        {value:"15",label:"15 Mins"},
                                        {value:"30",label:"30 Mins"},
                                        {value:"60",label:"1 Hour"},
                                        {value:"120",label:"2 Hours"},
                                        {value:"300",label:"5 Hours"},
                                    ]} />	
                            </div> */}
							<div class="col-xl-2 col-lg-2 form-group" style={{paddingTop:"30px"}}>
								<label></label>
								<button type="submit" onClick={this.onClickFilterSafetyReport.bind(this)} class="btn btn-success">Get Data</button>
							</div>
						</div>
                        {/* <p>Note* : Data can be fetched only for 5 days window</p> */}
                        <div id="myGrid" style={{width:"100%",height:"460px"}} className={"ag-theme-balham"}>    
                        <AgGridReact
                            columnDefs={columnWithDefs}
                            defaultColDef={this.state.defaultColDef}
                            rowData={this.state.rowData}
                            enableCharts={false}
                            // autoGroupColumnDef={this.state.autoGroupColumnDef}
                            onGridReady={this.onGridReady}
                            onGridState={this.onGridState}
                            frameworkComponents={this.state.frameworkComponents}
                            statusBar={this.state.statusBar}
                            sideBar={this.state.sideBar}
                            stopEditingWhenGridLosesFocus= {true}
                            paginationPageSize={1000}
                            pagination={true}
                            gridOptions={{
                                context: { componentParent: this },
                            }}
                            // components={this.state.components}
                            enableRangeSelection= {true}
                            // onCellClicked={this.onCellClickedInTransit.bind(this)}
                            // onCellEditingStopped={this.onCellUpdateData.bind(this)}
                            />
                        </div>
                        {/* <p className="float-right" style = {{fontWeight:"bold"}}> Showing Rows {this.state.alrData+" of "+this.state.total_data} </p>
                        <div className="row col-xl-12"  style ={{marginTop:"2%"}}>
                            <div className="col-lg-6">
                                {this.state.page_no > 0 ?
                                <button type="submit" onClick={this.onClickPreviousData.bind(this)} className="btn btn-success">Previous</button>
                                :""}
                            </div>
                            <div className="col-lg-6">
                                {this.state.rowData.length >= 1000?
                                <button type="submit" onClick={this.onClickNextData.bind(this)} className="btn btn-success float-right">Next</button>
                                :""}
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className={"dataLoadpage " +(this.state.loadshow)}>
                </div>
                <div className={"dataLoadpageimg " +(this.state.loadshow)}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>

				{this.state.sliderRouteTranslate != ''?
					 <div className={"slide-r "+(this.state.sliderRouteTranslate)} style={{overflow:"auto"}}>
					 	<div className="slide-r-title">
							<h4>
								View Route
                                <span className="float-right closebtn" style={{marginRight:"25px"}} 
                                onClick={this.onClickHideAll.bind(this)} >X</span>
										
							</h4>
						</div>
						<div className="slide-r-body" style={{position:"relative"}}>
							
							{/* <div className="row col-xl-12 col-lg-12 ml-0p n-p-0">
                                <DrawMap 
                                    context={this} 
                                    mapFor={"truck"} 
                                    mapinfo={this.state.mapinfo}  />
							</div> */}
                        </div>
                    </div>
                :""}
				
            </div>
            </> 
        );
    }
}


// eslint-disable-next-line no-unused-vars
function loadScript(url){
    var index  =window.document.getElementsByTagName("script")[0]
    var script = window.document.createElement("script")
    script.src=url
    script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}

function dateComparator1(date1,date2){
	//console.log(date1,date2);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split("-")[1]);
	date1 = date1.replace(date1.split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split("-")[1]);
	date2 = date2.replace(date2.split("-")[1],date_2);
	var date1Number = monthToComparableNumber1(date1);
	var date2Number = monthToComparableNumber1(date2);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}	
}

function monthToComparableNumber1(date) {
	console.log(date.length);
	console.log(date);
	if (date === undefined || date === null || date.length !== 10) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}
function dateComparator(date1, date2) {
	// console.log("dateComparator");
	// console.log(date1.length);
	if(date1 != "" && date2 != "" && date1 != undefined && date2 != undefined ){
		// console.log(date1,date2);
	var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
	date1 = date1.replace(date1.split(" ")[0].split("-")[1],date_1);
	var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
	date2 = date2.replace(date2.split(" ")[0].split("-")[1],date_2);
	// console.log(date1,date2);
	var date1Number = monthToComparableNumber(date1);
	var date2Number = monthToComparableNumber(date2);
	// console.log(date1Number,date2Number);
	if (date1Number === null && date2Number === null) {
	  return 0;
	}
	if (date1Number === null) {
	  return -1;
	}
	if (date2Number === null) {
	  return 1;
	}
	return date1Number - date2Number;
	}
  }
function monthToComparableNumber(date) {
	// console.log(date,date.length);
	if (date === undefined || date === null || date.length !== 16) {
		return null;
	}
	var yearNumber = date.substring(6, 10);
	var monthNumber = date.substring(3, 5);
	var dayNumber = date.substring(0, 2);
	console.log(yearNumber,monthNumber,dayNumber);
	var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
	return result;
}

function getMonthNumber(monthName){
	var months = [
		'Jan', 'Feb', 'Mar', 'Apr', 'May',
		'Jun', 'Jul', 'Aug', 'Sep',
		'Oct', 'Nov', 'Dec'
		];
	var monthNum = months.indexOf(monthName)+1;
	if(monthNum < 10){
		monthNum = "0"+monthNum.toString();
	}
	return monthNum;
}


function loadDateTimeScript(){
	// alert("timeDate");
	$('.datetimepicker_mask').datetimepicker({
		format:'d-m-Y H:i'
	});
	$('.datetimepicker_date').datetimepicker({
		format:'Y-m-d',
		timepicker:false
	});
    var index  =window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src="https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
	//script.src="http://xdsoft.net/jqplugins/datetimepicker/"
	script.async=true
    script.defer = true
    index.parentNode.insertBefore(script,index)
}

$(document).on("change", "#sttoDate", function(e) {
    e.preventDefault();
    var bookingDate=$("#ndfromDate").val();
    var cargoDate=$("#ndtoDate").val();
    // var bookingDate = bookingDate.split("-")[2]+"-"+bookingDate.split("-")[1]+"-"+bookingDate.split("-")[0]
    // var cargoDate = cargoDate.split("-")[2]+"-"+cargoDate.split("-")[1]+"-"+cargoDate.split("-")[0]
    console.log()
    var startDate = new Date(bookingDate);
    var endDate = new Date(cargoDate);
    var startTime = startDate.getTime();
    var endTime = endDate.getTime();
    console.log(startTime,endTime);
    if (startTime > endTime) {
        $("#ndtoDate").val("");
        alert("To Date should be greater than or equal to From Date");
    }
})

$(document).on("change", "#ndfromDate", function(e) {
    e.preventDefault();
    var bookingDate=$("#ndfromDate").val();
    var cargoDate=$("#ndtoDate").val();
    // var bookingDate = bookingDate.split("-")[2]+"-"+bookingDate.split("-")[1]+"-"+bookingDate.split("-")[0]
    // var cargoDate = cargoDate.split("-")[2]+"-"+cargoDate.split("-")[1]+"-"+cargoDate.split("-")[0]

    var startDate = new Date(bookingDate);
    var endDate = new Date(cargoDate);
    var startTime = startDate.getTime();
    var endTime = endDate.getTime();
    console.log(startTime,endTime);
    if(startTime > endTime)
    {
        $("#ndfromDate").val("");
        alert("From Date should be less than equal to To Date");
    }
})

function DateEditor () {}

// gets called once before the renderer is used
DateEditor.prototype.init = function(params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd hh:mm",
        changeMonth: true,
        changeYear: true,
        timepicker: true,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function() {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function() {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function() {
	// console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function() {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function() {
    // and we could leave this method out also, false is the default
    return false;
};

function NumericCellEditor() {
}

// gets called once before the renderer is used
NumericCellEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function getCharCodeFromEvent(event) {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
}

function isCharDecimal(charStr) {
    return !!/\./.test(charStr);
}

function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr);
}

NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
NumericCellEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
NumericCellEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
NumericCellEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
NumericCellEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};


function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
}
function secondsToHM(seconds) {
    seconds = Number(seconds);
   
    
    var hh = Math.floor((seconds / 3600));
    var hrr = Math.floor(seconds - (hh*3600));
    var mm = Math.floor(hrr/60)
    if(mm < 10)
    {
        var mins = "0"+mm;
    }
    else
    {
        var mins = mm;
    }

    if(hh < 10)
    {
        var hrs = "0"+hh;
    }
    else
    {
        var hrs = hh;
    }
    return hrs+":"+mins;
}

function secondsToString(seconds)
{
var numdays = Math.floor(seconds / 86400);
var numhours = Math.floor((seconds % 86400) / 3600);
var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
var numseconds = ((seconds % 86400) % 3600) % 60;
return numdays + " days " + numhours + " hours " + numminutes + " minutes ";
}